<div class='reset-password-page' fxFill fxLayout='column' fxLayoutAlign='center center'>
  <mat-card appearance="outlined" class='reset-password-card mat-elevation-z2'>
    <mat-toolbar color='primary' fxLayout='row' fxLayoutAlign='start center'>
      <h2 class='mat-toolbar-tools'>Password Reset</h2>
    </mat-toolbar>
    <mat-card-content cdkTrapFocus>
      @if (!(beenChecked$ | async)) {
        <mat-progress-spinner mode='indeterminate'></mat-progress-spinner>
      } @else {
        @if (valid$ | async) {
          <dash-gis-reset-password-form (formSubmit)='resetPassword($event)'
          (formCancel)='cancelReset()'></dash-gis-reset-password-form>
        } @else {
          <div>The link you provided is invalid or expired. Please check it or try again from the login page.</div>
          <button (click)='cancelReset()'>Back to Login</button>
        }
      }
    </mat-card-content>
  </mat-card>
</div>






